// @owners { team: patients }
import { TOTAL_PRICE_PENDING } from '~shared/features/pricing/constants';
import { selectedPriceOption } from '~shared/features/pricing/helpers';
import { type Pricing } from '~shared/features/pricing/types';
import { formatDollarsWithPlaceholder } from '~shared/helpers/currency';

export type AttestationPriceDisplay = {
  label: string;
  price: string;
};

const RETAIL_LABEL = 'Retail price';
const POST_ATTESTATION_LABEL = 'Your price';
const PRICE_UNAVAILABLE = 'Price unavailable';

export const getRetailPriceDisplay = (pricing: Pricing | undefined): AttestationPriceDisplay => {
  if (!pricing?.prices?.length) {
    return { label: RETAIL_LABEL, price: PRICE_UNAVAILABLE };
  }

  const option = selectedPriceOption(pricing.prices, 'without_insurance');
  return {
    label: RETAIL_LABEL,
    price: formatDollarsWithPlaceholder(option?.price, PRICE_UNAVAILABLE),
  };
};

// TODO(PH-3737): confirm post-attestation price source after POST /v1/attestations (plan §8 #3).
// Do not map from with_insurance — attestation programs bypass insurance; that option is not the program discount.
export const getDiscountedPriceDisplay = (pricing: Pricing | undefined): AttestationPriceDisplay => {
  void pricing;
  return {
    label: POST_ATTESTATION_LABEL,
    price: TOTAL_PRICE_PENDING,
  };
};
